import { addCommonValidationRules } from '@modules/husleie-framework/src/validations/addCommonValidationRules';
import { addNORValidationRules } from '@modules/husleie-framework/src/validations/nor/addNORValidationRules';
import type FetchValidationRulesConfig from '@modules/store/common/types/FetchValidationRulesConfig.entity';
import type ValidationRuleEntries from '@modules/store/common/types/ValidationRuleEntries.entity';

export function getValidationRules(config: FetchValidationRulesConfig): ValidationRuleEntries {
  addCommonValidationRules(config);
  addNORValidationRules(config);

  return {};
}
